import { Model } from '@vuex-orm/core'

export default class Evaluation extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'evaluations'

  static primaryKey = '_id'

  // List of all fields (schema) of the post model. `this.attr` is used
  // for the generic field type. The argument is the default value.
  static fields () {
    return {
      _id: this.attr(null),
      candidate_id: this.attr(null),
      job_id: this.attr(null),
      stage_id: this.attr(null),
      scoreform_id: this.attr(null),
      scorecard: this.attr(null),
      groups: this.attr(null),
      score: this.attr(null),
      comment: this.attr(null),
      guest: this.attr(null),
      author_user_id: this.attr(null)
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/Evaluation.js